export default __webpack_public_path__ + "media/images/edit-quiz-01f986723f32bfaea14eaa9af37be35a.png";